import { BarChart, Bar, BarProps } from "recharts";
import { ChartConfig, ChartContainer, ChartTooltip, ChartTooltipContent } from "../ui/chart";
import { FunnelBar } from "../custom-ui/charts/funnel.bar";

const chartConfig: ChartConfig = {
  showLook: {
    label: "Общее кол-во показов",
    color: "hsl(var(--chart-1))",
  },
  showCard: {
    label: "Показ → Карточка",
    color: "hsl(var(--chart-2))",
  },
  cardBasket: {
    label: "Карточка → корзина",
    color: "hsl(var(--chart-3))",
  },
  basketOrder: {
    label: "Корзина → заказ",
    color: "hsl(var(--chart-4))",
  },
};

interface FunnelChartProps {
  data: IFunnelChartData[];
}

export interface IFunnelChartData {
  key: string;
  value: number;
  fill: string;
}

export const FunnelChart = ({ data }: FunnelChartProps) => {
  return (
    <ChartContainer config={chartConfig} className="w-full h-72">
      <BarChart
        accessibilityLayer
        data={data}
        layout="horizontal"
        margin={{ top: 0, right: 10, left: 10, bottom: 0 }}
        barCategoryGap="1%"
      >
        <ChartTooltip
          content={<ChartTooltipContent nameKey="key" label={true} className="w-64" />}
        />

        <Bar dataKey="value" shape={(props: BarProps) => <FunnelBar props={props} data={data} />} />
      </BarChart>
    </ChartContainer>
  );
};
